import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import API from "../services/api";
import "./loginngo.css";

export default function LoginNgo() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await API.post("/ngo/login", {
        email: email,
        password: password,
      });

      const user = response.data;

      // Store login info
      localStorage.setItem("userId", user.id);
      localStorage.setItem("role", "NGO");
      localStorage.setItem("ngoEmail", user.email);   // ✅ ADD THIS

      navigate("/ngo/dashboard");
    } catch (err) {
      setError("Invalid email or password");
    }
  };

  return (
    <div className="login-page">

      <img
        src="/images/food-waste.webp"
        alt="Food waste"
        className="login-bg"
      />

      <div className="login-overlay"></div>

      <div className="login-popup">
        <h1 className="brand">SaveBite</h1>
        <p className="tagline">Because every plate counts 🍽️</p>

        <form onSubmit={handleLogin} autoComplete="off">
          <input
            type="email"
            placeholder="NGO Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && <div className="error">{error}</div>}

          <button type="submit" className="login-btn">
            Login
          </button>
        </form>

        <div className="register-text">
          Don’t have an account?{" "}
          <Link to="/register">Register</Link>
        </div>
      </div>

      <div className="footer">
        © 2025 SaveBite. All rights reserved.
      </div>
    </div>
  );
}
